import script from "./ConstructorDatabase.vue?vue&type=script&setup=true&lang=js"
export * from "./ConstructorDatabase.vue?vue&type=script&setup=true&lang=js"

import "./ConstructorDatabase.vue?vue&type=style&index=0&id=65ca856a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65ca856a"]])

export default __exports__